import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RoomGallery from "./RoomGallery";
import { useContext } from "react";
import { AuthContext } from "../../clients/utils/AuthContext";




function RoomList({ rooms, checkIn, checkOut, prices }) {

  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  
  const nights =
    checkIn && checkOut
      ? Math.ceil(
          (new Date(checkOut) - new Date(checkIn)) /
            (1000 * 60 * 60 * 24)
        )
      : 0;

  return (
    <div className="mt-12" id="rooms">

      {/* HEADER */}
      <div className="mb-8">
        <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-gray-900">
          Chambres disponibles
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Choisissez la chambre qui correspond à votre séjour
        </p>
      </div>

      {/* LIST */}
      <div className="flex flex-col gap-6">

        {rooms?.map((room, index) => {
          const roomData = prices?.find(p => p.roomId === room._id);

          const dispo = roomData?.available;
          const isDisabled = !roomData?.isAvailable;

          // 🔥 récupérer tous les rates (sur la première nuit par ex)
          const firstDay = roomData?.days?.[0];
          const rates = firstDay?.rates || [];

          // 🔥 prendre le moins cher
          const cheapestRate = rates.length > 0
            ? rates.reduce((min, r) => r.price < min.price ? r : min, rates[0])
            : null;

          const total =
            checkIn && checkOut
              ? roomData?.total
              : cheapestRate?.price || room.price;
          

          return (
            <div
              key={room._id}
              className="
              group
              bg-white rounded-2xl border border-gray-100
              p-4
              flex flex-col md:flex-row
              gap-6
              hover:shadow-xl
              transition-shadow duration-300
            "
            >

              {/* IMAGE */}
              <RoomGallery photos={room.photos} />


              {/* INFOS */}
              <div className="flex-1">

                {/* TOP */}
                <div className="flex flex-wrap items-center gap-3">

                  <h3 className="text-lg font-semibold text-gray-900">
                    {room.title}
                  </h3>
                  

                  {/* DISPONIBILITÉ */}
                  {dispo > 0 ? (
                    dispo <= 2 ? (
                      <span className="text-xs bg-red-50 text-red-600 px-2 py-1 rounded-md font-medium">
                        Plus que {dispo} restantes
                      </span>
                    ) : (
                      <span className="text-xs bg-green-50 text-green-600 px-2 py-1 rounded-md font-medium">
                        Disponible
                      </span>
                    )
                  ) : (
                    <span className="text-xs bg-gray-100 text-gray-500 px-2 py-1 rounded-md font-medium">
                      Complet
                    </span>
                  )}

                </div>

                {/* DESC */}
                <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                  {room.desc}
                </p>

                {/* CAPACITÉ */}
                <p className="text-xs text-gray-500 mt-2">
                  Jusqu'à {room.maxPeople} personnes
                </p>

                

                {/* MESSAGE SI PAS DE DATES */}
                {!checkIn || !checkOut ? (
                  <p className="text-xs text-orange-500 mt-2">
                    Sélectionnez vos dates pour réserver
                  </p>
                ) : null}

                {/* FEATURES */}
                <div className="flex flex-wrap gap-2 mt-4">
                  {room.features?.map((f, i) => (
                    <span
                      key={i}
                      className="
                        text-xs bg-gray-100 px-2 py-1 rounded-md text-gray-600
                        group-hover:bg-gray-200 transition
                      "
                    >
                      {f}
                    </span>
                  ))}
                </div>

              </div>

              {/* PRIX + CTA */}
              <div className="flex flex-col justify-between items-end w-full md:w-auto md:min-w-[160px]">

                <div className="text-right">

                  {/* 🔥 PROMO */}
                  {cheapestRate && cheapestRate.price < room.price && (
                    <div className="mb-1 inline-block text-xs text-green-700 bg-green-50 px-2 py-0.5 rounded-md font-medium">
                      Offre spéciale
                    </div>
                  )}

                  {/* LABEL */}
                  <p className="text-sm text-gray-500">
                    {checkIn && checkOut ? "Séjour" : "À partir de"}
                  </p>

                  {/* PRIX */}
                  <p className="text-2xl font-semibold text-gray-900">
                    {checkIn && checkOut ? `${total}€` : `${room.price}€`}
                  </p>

                  {/* NUITS */}
                  {checkIn && checkOut && (
                    <p className="text-xs text-gray-400 mt-1">
                      {nights} nuit{nights > 1 && "s"}
                    </p>
                  )}

                </div>

                <button
                  onClick={() => {

                    // ❌ pas de dates → scroll
                    if (!checkIn || !checkOut) {
                      document.getElementById("booking")?.scrollIntoView({
                        behavior: "smooth",
                      });
                      return;
                    }

                    // ✅ OK → checkout
                    navigate(
                      `/checkout?room=${room._id}&checkIn=${checkIn}&checkOut=${checkOut}`
                    );
                  }}
                  disabled={isDisabled}
                  className={`
                    mt-4 w-full md:w-auto
                    px-5 py-2.5 rounded-lg text-sm font-medium
                    transition-all duration-200

                    ${isDisabled
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-[#3A9D23] text-white hover:bg-[#33891E] active:scale-[0.97]"
                    }
                  `}
                >
                  {!checkIn || !checkOut
                    ? "Choisir des dates"
                    : isDisabled
                    ? "Indisponible"
                    : "Réserver"}
                </button>

              </div>

            </div>
          );
        })}

      </div>

      

    </div>
  );
}

export default RoomList;